module.exports = __webpack_public_path__ + "img/about-business-pic.b1d74e55.jpg";